module.exports = __webpack_public_path__ + "img/cq6.537f8616.jpg";